import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#f49d3f',
      contrastText: '#ffffff', // Replace with your primary color
    },
    secondary: {
      main: '#ffffff', // Replace with your secondary color
    },
    error: {
      main: '#f44336', // Replace with your error color
    },
    warning: {
      main: '#ff9800', // Replace with your warning color
    },
    info: {
      main: '#2196f3', // Replace with your info color
    },
    success: {
      main: '#4caf50', // Replace with your success color
    },
    text: {
      primary: '#000000',
      secondary: '#000000',
    },
  },
  components: {
    MuiTextField: {
      styleOverrides: {
        root: {
          '&.darkBackground': {
            '& .MuiInputBase-input': {
              color: 'white',
            },
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                border: '2px solid white',
              },
              '&:hover fieldset': {
                border: '2px solid white',
              },
              '&.Mui-focused fieldset': {
                border: '2px solid white',
              },
              '&.Mui-disabled fieldset': {
                border: '2px solid #999999',
                color: '#999999',
              },
            },
            '& .MuiInputBase-input.Mui-disabled': {
              WebkitTextFillColor: '#999999',
            },
            '& input': {
              '&:-webkit-autofill': {
                '-webkit-box-shadow':
                  '0 0 0 100px transparent inset !important',
                '-webkit-text-fill-color': 'white !important',
                transition: 'background-color 5000s ease-in-out 0s',
              },
              '&:-webkit-autofill:hover': {
                '-webkit-box-shadow':
                  '0 0 0 100px transparent inset !important',
                '-webkit-text-fill-color': 'white !important',
              },
              '&:-webkit-autofill:focus': {
                '-webkit-box-shadow':
                  '0 0 0 100px transparent inset !important',
                '-webkit-text-fill-color': 'white !important',
              },
            },
            '& .MuiInputLabel-root': {
              color: 'white',
            },
            '& .MuiInputLabel-root.Mui-focused': {
              color: 'white',
            },
            '& .MuiInputLabel-root.Mui-disabled': {
              color: '#999999',
            },
          },
          '&.lightBackground': {
            '& .MuiInputBase-input': {
              color: '#000000a3',
            },
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                border: '2px solid #00000026',
              },
              '&:hover fieldset': {
                border: '2px solid #00000026',
              },
              '&.Mui-focused fieldset': {
                border: '2px solid #00000026',
              },
              '&.Mui-disabled fieldset': {
                border: '2px solid #999999',
                color: '#999999',
              },
            },
            '& .MuiInputBase-input.Mui-disabled': {
              WebkitTextFillColor: '#999999',
            },
            '& input': {
              '&:-webkit-autofill': {
                '-webkit-box-shadow':
                  '0 0 0 100px transparent inset !important',
                '-webkit-text-fill-color': '#00000026 !important',
                transition: 'background-color 5000s ease-in-out 0s',
              },
              '&:-webkit-autofill:hover': {
                '-webkit-box-shadow':
                  '0 0 0 100px transparent inset !important',
                '-webkit-text-fill-color': '#00000026 !important',
              },
              '&:-webkit-autofill:focus': {
                '-webkit-box-shadow':
                  '0 0 0 100px transparent inset !important',
                '-webkit-text-fill-color': '#00000026 !important',
              },
            },
            '& .MuiInputLabel-root': {
              color: '#00000026',
            },
            '& .MuiInputLabel-root.Mui-focused': {
              color: '#00000026',
            },
            '& .MuiInputLabel-root.Mui-disabled': {
              color: '#999999',
            },
          },
        },
      },
    },
    MuiAccordion: {
      variants: [
        {
          props: { variant: 'transparent' },
          style: {
            backgroundColor: 'transparent',
            boxShadow: 'none',
            '&:before': {
              display: 'none',
            },
            borderColor: 'white',
            borderStyle: 'solid',
            borderWidth: '1px', // '1' should be '1px'
          },
        },
      ],
    },
    MuiAccordionSummary: {
      variants: [
        {
          props: { variant: 'transparent' },
          style: {
            backgroundColor: 'transparent',
            minHeight: 'auto',
            '& .MuiAccordionSummary-content': {
              margin: 0,
            },
            '& .MuiAccordionSummary-expandIconWrapper': {
              color: 'white',
            },
          },
        },
      ],
    },
    MuiAccordionDetails: {
      variants: [
        {
          props: { variant: 'transparent' },
          style: {
            backgroundColor: 'transparent',
          },
        },
      ],
    },
  },
});

export default theme;
